module.exports = __webpack_public_path__ + "static/media/learninganalytics.a496f3a7.jpg";